// ZERCODE CHANGE [STD-FE]: Berry shipped this menu state on SWR; the Zercode
// stack replaces SWR with TanStack Query (server state) + Zustand (UI state).
// Drawer open/close is pure UI state, so it lives in a Zustand store here.
// The export surface (useGetMenuMaster / handlerDrawerOpen) is kept identical
// so Berry layout components stay untouched.
import { create } from 'zustand';

// types
import { MenuProps } from 'types/menu';

interface MenuStore extends MenuProps {
  setDashboardDrawerOpened: (isOpen: boolean) => void;
}

const useMenuStore = create<MenuStore>()((set) => ({
  isDashboardDrawerOpened: false,
  setDashboardDrawerOpened: (isDashboardDrawerOpened) => set({ isDashboardDrawerOpened })
}));

export function useGetMenuMaster() {
  const isDashboardDrawerOpened = useMenuStore((state) => state.isDashboardDrawerOpened);

  return {
    menuMaster: { isDashboardDrawerOpened } as MenuProps,
    menuMasterLoading: false
  };
}

export function handlerDrawerOpen(isDashboardDrawerOpened: boolean) {
  useMenuStore.getState().setDashboardDrawerOpened(isDashboardDrawerOpened);
}
